import { customTheme } from '@aslanpay/portal-common-lib';

const theme = customTheme({
  fonts: {
    mono: 'Inconsolata, monospace',
  },
});

export default theme;
